var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/helpers/getChildren.ts";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
export function getChildren(tree, groupId) {
  var children = [];
  var target = tree.find(function (item) {
    return item.id === groupId;
  });

  function recursive(targ) {
    var _children = tree.filter(function (item) {
      return item.parentGroupId === targ.id;
    });

    _children.forEach(function (ch) {
      children.push(ch);
      recursive(ch);
    });
  }

  if (target) {
    recursive(target);
  }

  return children;
}